import { translate } from '@/components/utils/translations';

export const DEFAULT_GREETING_MESSAGE_TYPE = 'default_greeting';

const BRIEF_THINGS_KEYS = [
  'neoChatBriefThings1',
  'neoChatBriefThings2',
  'neoChatBriefThings3',
  'neoChatBriefThings4',
  'neoChatBriefThings5',
];

export const MEETING_TYPE_DEFS = [
  { value: 'discovery', labelKey: 'neoChatMeetingDiscovery' },
  { value: 'demo', labelKey: 'neoChatMeetingDemo' },
  { value: 'proposal', labelKey: 'neoChatMeetingProposal' },
  { value: 'negotiation', labelKey: 'neoChatMeetingNegotiation' },
  { value: 'renewal', labelKey: 'neoChatMeetingRenewal' },
  { value: 'qbr', labelKey: 'neoChatMeetingQbr' },
];

export function createDefaultGreetingMessage(language = null) {
  return {
    sender: 'bot',
    type: DEFAULT_GREETING_MESSAGE_TYPE,
    text: translate('neoChatDefaultGreeting', language),
    id: Date.now(),
  };
}

export function isDefaultGreetingMessage(message) {
  if (message?.type === DEFAULT_GREETING_MESSAGE_TYPE) return true;
  return (
    message?.sender === 'bot' &&
    !message?.type &&
    typeof message?.text === 'string' &&
    message.text.includes("Hello! I'm NEO")
  );
}

export function getSuggestionChips(t) {
  return [
    {
      label: t('neoChatChipShowTenders'),
      prompt: t('neoChatPromptShowTenders'),
      requires: 'show_tenders',
    },
    {
      label: t('neoChatChipMeetingPrep'),
      prompt: t('neoChatPromptMeetingPrep'),
      requires: 'meeting_prep',
    },
  ];
}

export function getMeetingTypeLabel(t, value) {
  const def = MEETING_TYPE_DEFS.find((d) => d.value === value);
  return def ? t(def.labelKey) : value;
}

export function briefIntroThingsPhrase(itemCount, language = null) {
  const n = Math.min(5, Math.max(1, Number(itemCount) || 1));
  return translate(BRIEF_THINGS_KEYS[n - 1], language);
}

export function composeBriefIntro(greeting, userFirstName, itemCount, language = null) {
  const g = String(greeting || translate('neoChatBriefGreetingFallback', language)).trim();
  const things = briefIntroThingsPhrase(itemCount, language);
  const firstName = userFirstName != null ? String(userFirstName).trim() : '';
  if (firstName) return `${g}, ${firstName} — ${things}:`;
  return `${g} — ${things}:`;
}

export function composeTriggerIntro(itemCount, language = null) {
  const n = Math.min(5, Math.max(1, Number(itemCount) || 1));
  return n === 1
    ? translate('neoChatTriggerIntroOne', language)
    : translate('neoChatTriggerIntroMany', language);
}
